// extracted by mini-css-extract-plugin
export default {"title":"_013cbffeb9","inner_title":"e1f5746f12","charge_btn":"_7bf55db171"};